import { useState, useContext } from "react";
import { FilterContext } from "../FilterContextProvider";

const useDateSelections = () => {
  const { filterData, setFilterData } = useContext(FilterContext);
  const [disable, setDisable] = useState(true);

  const dateOptions = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This month", value: "this_month" },
    { label: "Last month", value: "last_month" },
    { label: "This year", value: "this_year" },
    { label: "Last year", value: "last_year" },
    { label: "First quarter", value: "first_quarter" },
    { label: "Second quarter", value: "second_quarter" },
    { label: "Third quarter", value: "third_quarter" },
    { label: "Fourth quarter", value: "fourth_quarter" },
    { label: "All time", value: "all_time" },
    { label: "Custom", value: "custom" },
  ];

  const date = new Date().toISOString().slice(0, 10);
  const day = new Date().toISOString().slice(8, 10);
  const month = new Date().toISOString().slice(5, 7);
  const year = new Date().toISOString().slice(0, 4);

  const handleDateSelect = (e) => {
    setDisable(false);
    switch (e.target?.id || e.value) {
      case "today":
        return setFilterData({
          ...filterData,
          date_button: "today",
          start_date: date,
          end_date: date,
        });
      case "yesterday":
        if (day === "01") {
          if (month === "01") {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year - 1}-12-31`,
              end_date: `${year - 1}-12-31`,
            });
          } else if (
            month === "02" ||
            month === "04" ||
            month === "06" ||
            month === "08" ||
            month === "09"
          ) {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year}-0${month - 1}-31`,
              end_date: `${year}-0${month - 1}-31`,
            });
          } else if (month === "11") {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year}-${month - 1}-31`,
              end_date: `${year}-${month - 1}-31`,
            });
          } else if (month === "05" || month === "07" || month === "10") {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year}-0${month - 1}-30`,
              end_date: `${year}-0${month - 1}-30`,
            });
          } else if (month === "12") {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year}-${month - 1}-30`,
              end_date: `${year}-${month - 1}-30`,
            });
          } else if (month === "03" && year % 4 === 0) {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year}-02-29`,
              end_date: `${year}-02-29`,
            });
          } else if (month === "03" && year % 4 !== 0) {
            return setFilterData({
              ...filterData,
              date_button: "yesterday",
              start_date: `${year}-02-28`,
              end_date: `${year}-02-28`,
            });
          }
        } else {
          return setFilterData({
            ...filterData,
            date_button: "yesterday",
            start_date: `${year}-${month}-${day - 1}`,
            end_date: `${year}-${month}-${day - 1}`,
          });
        }
        break;
      case "this_month":
        if (
          month === "01" ||
          month === "03" ||
          month === "05" ||
          month === "07" ||
          month === "08" ||
          month === "10" ||
          month === "12"
        ) {
          return setFilterData({
            ...filterData,
            date_button: "this_month",
            start_date: `${year}-${month}-01`,
            end_date: `${year}-${month}-31`,
          });
        } else if (
          month === "04" ||
          month === "06" ||
          month === "09" ||
          month === "11"
        ) {
          return setFilterData({
            ...filterData,
            date_button: "this_month",
            start_date: `${year}-${month}-01`,
            end_date: `${year}-${month}-30`,
          });
        } else if (month === "02" && year % 4 === 0) {
          return setFilterData({
            ...filterData,
            date_button: "this_month",
            start_date: `${year}-02-01`,
            end_date: `${year}-02-29`,
          });
        } else if (month === "02" && year % 4 !== 0) {
          return setFilterData({
            ...filterData,
            date_button: "this_month",
            start_date: `${year}-02-01`,
            end_date: `${year}-02-28`,
          });
        }
        break;
      case "last_month":
        if (month === "01") {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year - 1}-12-01`,
            end_date: `${year - 1}-12-31`,
          });
        } else if (
          month === "02" ||
          month === "04" ||
          month === "06" ||
          month === "08" ||
          month === "09"
        ) {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year}-0${month - 1}-01`,
            end_date: `${year}-0${month - 1}-31`,
          });
        } else if (month === "11") {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year}-${month - 1}-01`,
            end_date: `${year}-${month - 1}-31`,
          });
        } else if (month === "05" || month === "07" || month === "10") {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year}-0${month - 1}-01`,
            end_date: `${year}-0${month - 1}-30`,
          });
        } else if (month === "12") {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year}-${month - 1}-01`,
            end_date: `${year}-${month - 1}-30`,
          });
        } else if (month === "03" && year % 4 === 0) {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year}-02-01`,
            end_date: `${year}-02-29`,
          });
        } else if (month === "03" && year % 4 !== 0) {
          return setFilterData({
            ...filterData,
            date_button: "last_month",
            start_date: `${year}-02-01`,
            end_date: `${year}-02-28`,
          });
        }
        break;
      case "this_year":
        return setFilterData({
          ...filterData,
          date_button: "this_year",
          start_date: `${year}-01-01`,
          end_date: `${year}-12-31`,
        });
      case "last_year":
        return setFilterData({
          ...filterData,
          date_button: "last_year",
          start_date: `${year - 1}-01-01`,
          end_date: `${year - 1}-12-31`,
        });
      case "first_quarter":
        return setFilterData({
          ...filterData,
          date_button: "first_quarter",
          start_date: `${year}-01-01`,
          end_date: `${year}-03-31`,
        });
      case "second_quarter":
        return setFilterData({
          ...filterData,
          date_button: "second_quarter",
          start_date: `${year}-04-01`,
          end_date: `${year}-06-30`,
        });
      case "third_quarter":
        return setFilterData({
          ...filterData,
          date_button: "third_quarter",
          start_date: `${year}-07-01`,
          end_date: `${year}-09-30`,
        });
      case "fourth_quarter":
        return setFilterData({
          ...filterData,
          date_button: "fourth_quarter",
          start_date: `${year}-10-01`,
          end_date: `${year}-12-31`,
        });
      case "all_time":
        return setFilterData({
          ...filterData,
          date_button: "all_time",
          start_date: `1900-01-01`,
          end_date: `2100-12-31`,
        });
      case "custom":
        return setFilterData({
          ...filterData,
          date_button: "custom",
          start_date: "",
          end_date: "",
        });
      default:
    }
  };

  const handleCustomStartDate = (e) => {
    setDisable(false);
    filterData.date_button === "custom" &&
      setFilterData({
        ...filterData,
        start_date: e.target.value,
      });
  };

  const handleCustomEndDate = (e) => {
    setDisable(false);
    filterData.date_button === "custom" &&
      setFilterData({
        ...filterData,
        end_date: e.target.value,
      });
  };

  const renderDateOptions = () => {
    return (
      <div className="text-xs ml-2 tracking-normal">
        {dateOptions.map((date) => {
          return (
            <div key={date.value} className="my-3">
              <input
                className="mr-2 align-bottom"
                onChange={handleDateSelect}
                type="radio"
                checked={filterData.date_button === date.value}
                id={date.value}
                name="date"
                value={filterData.date_button ?? ""}
              />
              <label htmlFor={date.value}>{date.label}</label>
            </div>
          );
        })}
      </div>
    );
  };

  const renderTwoColumnDateOptions = () => {
    return (
      <div className="flex justify-between text-xs ml-2 tracking-normal">
        <div>
          {dateOptions.slice(0, 6).map((date) => {
            return (
              <div key={date.value} className="my-3">
                <input
                  className="mr-2 align-bottom"
                  onChange={handleDateSelect}
                  type="radio"
                  checked={filterData.date_button === date.value}
                  id={date.value}
                  name="date"
                  value={filterData.date_button ?? ""}
                />
                <label htmlFor={date.value}>{date.label}</label>
              </div>
            );
          })}
        </div>
        <div className="">
          {dateOptions.slice(6, 12).map((date) => {
            return (
              <div key={date.value} className="my-3">
                <input
                  className="mr-2 align-bottom"
                  onChange={handleDateSelect}
                  type="radio"
                  checked={filterData.date_button === date.value}
                  id={date.value}
                  name="date"
                  value={filterData.date_button ?? ""}
                />
                <label htmlFor={date.value}>{date.label}</label>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderCustomDateSelector = () => {
    return (
      <div
        className={
          filterData.date_button === "custom"
            ? "flex text-xs text-black"
            : "flex text-xs text-gray-400"
        }
      >
        <div className="flex flex-col w-1/2 mr-2">
          <label htmlFor="start_date">From</label>
          <input
            value={filterData.start_date ?? ""}
            disabled={filterData.date_button !== "custom"}
            type="date"
            id="start_date"
            className="h-10 pl-2 rounded-md border"
            onChange={handleCustomStartDate}
          ></input>
        </div>
        <div className="flex flex-col w-1/2">
          <label htmlFor="end_date">To</label>
          <input
            value={filterData.end_date ?? ""}
            disabled={filterData.date_button !== "custom"}
            type="date"
            id="end_date"
            className="h-10 pl-2 rounded-md border"
            onChange={handleCustomEndDate}
          ></input>
        </div>
      </div>
    );
  };

  return {
    disable,
    setDisable,
    dateOptions,
    renderDateOptions,
    renderTwoColumnDateOptions,
    renderCustomDateSelector,
    handleDateSelect,
  };
};

export default useDateSelections;
